import { useMemo } from "react";
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Filler, Title, Tooltip, Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Title, Tooltip, Legend);

const MONTHS_FULL  = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const MONTHS_SHORT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

export function PaymentMethodChart({ payments, height = "250px" }) {
  const currentYear = new Date().getFullYear();

  const { pixByMonth, cardByMonth } = useMemo(() => {
    const pix  = new Array(12).fill(0);
    const card = new Array(12).fill(0);
    payments.forEach(p => {
      if (p.status !== "paid") return;
      const d = new Date(p.created_at);
      if (d.getFullYear() !== currentYear) return;
      const m = d.getMonth();
      const val = (p.price_in_cents || 0) / 100;
      if (p.payment_method === "pix") pix[m] += val;
      else card[m] += val;
    });
    return { pixByMonth: pix, cardByMonth: card };
  }, [payments, currentYear]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: ctx => ` ${ctx.dataset.label}: ${parseFloat(ctx.raw).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`,
        },
      },
    },
    scales: {
      x: { grid: { color: "rgba(0,0,0,.04)" }, ticks: { font: { size: 10 }, color: "#a0aec0" } },
      y: {
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: { font: { size: 10 }, color: "#a0aec0", callback: v => `R$${(v / 1000).toFixed(0)}k` },
        beginAtZero: true,
      },
    },
  };

  const data = {
    labels: MONTHS_SHORT,
    datasets: [
      {
        label: "PIX",
        data: pixByMonth,
        borderColor: "#27ae60",
        backgroundColor: "rgba(39,174,96,.12)",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
      {
        label: "Cartão",
        data: cardByMonth,
        borderColor: "#2980b9",
        backgroundColor: "rgba(41,128,185,.12)",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
    ],
  };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Line options={options} data={data} />
    </div>
  );
}
